export default __webpack_public_path__ + "slices/main/assets/public/media/social/culture-amp-insights-thumb@2x.a209011333929072720873149168c708.png";